import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { navigationLinks } from '@/mocks/homepage';

export default function Navbar() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const location = useLocation();

  const isHomePage = location.pathname === '/';

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll, { passive: true });
    handleScroll();
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    setIsMobileMenuOpen(false);
  }, [location]);

  const isActive = (href: string) => {
    const cleanHref = href.split('?')[0];
    if (cleanHref === '/') {
      return location.pathname === '/';
    }
    return location.pathname.startsWith(cleanHref);
  };

  const isHeroTransparent = isHomePage && !isScrolled;

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        isScrolled
          ? 'bg-background-50/95 backdrop-blur-md border-b border-background-200/70'
          : 'bg-transparent'
      }`}
    >
      <div className="w-full px-4 md:px-8">
        <div className="flex items-center justify-between h-16">
          <Link
            to="/"
            className="flex items-center gap-2 group"
          >
            <span className={`text-xl font-bold font-heading tracking-tight whitespace-nowrap transition-colors duration-300 ${
              isHeroTransparent ? 'text-white' : 'text-foreground-950'
            }`}>
              韩漫在线
            </span>
          </Link>

          <div className="hidden md:flex items-center gap-8">
            {navigationLinks.map((link) => (
              <Link
                key={link.href}
                to={link.href}
                className={`text-sm font-medium whitespace-nowrap transition-colors duration-200 relative py-2 ${
                  isActive(link.href)
                    ? isHeroTransparent ? 'text-white' : 'text-primary-600'
                    : isHeroTransparent ? 'text-white/70 hover:text-white' : 'text-foreground-700 hover:text-foreground-950'
                }`}
              >
                {link.label}
                {isActive(link.href) && (
                  <span className={`absolute bottom-0 left-1/2 -translate-x-1/2 w-5 h-0.5 rounded-full transition-colors duration-300 ${
                    isHeroTransparent ? 'bg-white' : 'bg-primary-500'
                  }`} />
                )}
              </Link>
            ))}
          </div>

          <div className="hidden md:flex items-center gap-4">
            <Link
              to="/category/all"
              className={`px-5 py-2 text-sm font-medium rounded-full transition-all duration-200 whitespace-nowrap cursor-pointer ${
                isHeroTransparent
                  ? 'bg-white text-foreground-950 hover:bg-white/90'
                  : 'bg-primary-500 text-background-50 hover:bg-primary-600'
              }`}
            >
              开始阅读
            </Link>
          </div>

          <button
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
            className={`md:hidden w-10 h-10 flex items-center justify-center transition-colors cursor-pointer ${
              isHeroTransparent ? 'text-white' : 'text-foreground-700 hover:text-foreground-950'
            }`}
            aria-label="菜单"
          >
            <i className={`text-xl ${isMobileMenuOpen ? 'ri-close-line' : 'ri-menu-line'}`} />
          </button>
        </div>
      </div>

      {isMobileMenuOpen && (
        <div className={`md:hidden border-t transition-colors duration-300 ${
          isHeroTransparent ? 'bg-black/80 border-white/10' : 'bg-background-50 border-background-200/70'
        }`}>
          <div className="px-4 py-4 flex flex-col gap-3">
            {navigationLinks.map((link) => (
              <Link
                key={link.href}
                to={link.href}
                className={`text-sm font-medium py-2 whitespace-nowrap transition-colors ${
                  isActive(link.href)
                    ? isHeroTransparent ? 'text-white' : 'text-primary-600'
                    : isHeroTransparent ? 'text-white/70 hover:text-white' : 'text-foreground-700 hover:text-foreground-950'
                }`}
              >
                {link.label}
              </Link>
            ))}
            <Link
              to="/category/all"
              className={`mt-2 px-5 py-2.5 text-sm font-medium rounded-full transition-all text-center whitespace-nowrap cursor-pointer ${
                isHeroTransparent
                  ? 'bg-white text-foreground-950 hover:bg-white/90'
                  : 'bg-primary-500 text-background-50 hover:bg-primary-600'
              }`}
            >
              开始阅读
            </Link>
          </div>
        </div>
      )}
    </nav>
  );
}